import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {TooltipPanelPosition} from './tooltip';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {FeatureFlagQuery} from '../../../common/elf-store/feature-flag/feature-flag.query';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';

@Component({
  selector: 'mc-tooltip-group-feature-panel',
  templateUrl: './tooltip-panel-group-feature.component.html',
  styleUrls: ['./tooltip-panel-group-feature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe()
// [NEW-GROUP] - disabled for ticket DASH-1168
// export class TooltipPanelGroupFeatureComponent implements OnInit {
export class TooltipPanelGroupFeatureComponent {
  featureFlagQuery = inject(FeatureFlagQuery);
  @Input() position: TooltipPanelPosition;
  @Input() forceOpen?: boolean;
  @Input() hideTriangle?: boolean;
  @Input() noHover?: boolean;

  // [NEW-GROUP] - disabled for ticket DASH-1168
  // groupsFeatureFlag = false;

  get tooltipPanelClass() {
    return `mc-tooltip-panel_${this.position} ${this.forceOpen ? 'active' : ''} ${
      this.hideTriangle ? 'triangle_hided' : ''
    } ${this.noHover ? 'no_hover' : ''}`;
  }

  // [NEW-GROUP] - disabled for ticket DASH-1168
  // ngOnInit() {
  // this[SUBSCRIPTIONS].add(
  //   this.featureFlagQuery.groupsFeature$.subscribe(groupsFeatureFlag => {
  //     this.groupsFeatureFlag = groupsFeatureFlag;
  //     if (this.groupsFeatureFlag) {
  //       this.hideTriangle = true;
  //     }
  //   }),
  // );
  // }
}
